import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import UnsubscribePage from './UnsubscribePage';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

// Simple client-side routing based on pathname
const isUnsubscribePage = window.location.pathname === '/unsubscribe';

// Handle redirect promise
msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().then((response) => {
    if (response) {
      // User just logged in via redirect
      console.log('Login successful:', response);
    }
  }).catch((error) => {
    console.error('Redirect error:', error);
  });

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  // Render unsubscribe page without MSAL (public page, no auth required)
  if (isUnsubscribePage) {
    root.render(
      <React.StrictMode>
        <UnsubscribePage />
      </React.StrictMode>
    );
  } else {
    // Render main app with MSAL authentication
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(); // Disabled to reduce console output
